import type { ReactNode } from 'react';
import { useAuth } from '../auth/auth-provider';

/**
 * Outer chrome shared by every route. While the auth state is bootstrapping
 * we render a thin loading bar so the user sees a stable page (no layout
 * shift between the `bootstrapping → anonymous|authenticated` transitions).
 */
export function RootLayout({ children }: { children: ReactNode }) {
  const auth = useAuth();
  return (
    <div className="flex min-h-full flex-col">
      {auth.status === 'bootstrapping' ? (
        <div
          role="progressbar"
          aria-label="Načítání aplikace"
          className="h-1 w-full animate-pulse bg-brand-500"
        />
      ) : null}
      <main className="flex-1">{children}</main>
    </div>
  );
}
